<template>
<div class="pagewide panel mtpage landingpage">


	<maincontent>
		<template v-slot:content>

            <template v-if="locale == 'ru'">

                <div class="slide slide1">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🧡 Кто мы такие?</span>
                        </div>
                        <div class="paragraph">
                            Мы — Snippity. Мы рассказываем малышам, что происходит в мире. Просто. По-доброму. С любовью.
                        </div>
                    </div>
                </div>

                <div class="slide slide2">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>📢 Как мы говорим?</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Тепло, но не сюсюкаем.</li>
                                <li>Умно, но не занудно.</li>
                                <li>Весело, но не превращаем всё в шутку.</li>
                                <li>По-честному, но не пугаем.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide3">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>👎 Что мы не любим?</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Страшные заголовки.</li>
                                <li>Сложные слова без объяснений.</li>
                                <li>Скуку. Скуку вообще никто не любит.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide4">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>👍 А что любим?</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Вопрос: «Почему?»</li>
                                <li>Широко открытые глаза</li>
                                <li>Когда ребёнок говорит: «Ещё покажи!»</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide5">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🖐 Готов попробовать?</span>
                        </div>
                        <div class="calltoaction">
                            <button class="button" @click="gotosignin">{{$t('app.registration')}}</button>
                        </div>
                        
                    </div>
                </div>

		    </template>

            <template v-if="locale == 'en'">
                <div class="slide slide1">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🧡 Who are we?</span>
                        </div>
                        <div class="paragraph">
                            We are Snippity. We tell kids what's going on in the world. Simple. Kind. With love.
                        </div>
                    </div>
                </div>

                <div class="slide slide2">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>📢 How do we speak?</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Warm, but not coy.</li>
                                <li>Smart, but not boring.</li>
                                <li>Fun, but not turning everything into a joke.</li>
                                <li>Honest, but not scary.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide3">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>👎 What don't we like?</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Scary headlines.</li>
                                <li>Complex words without explanation.</li>
                                <li>Boredom. Nobody likes boredom.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide4">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>👍 What do we like?</span>
                        </div>
                        <div class="list">
                            <ul>
                                <li>Question: "Why?"</li>
                                <li>Wide open eyes</li>
                                <li>When a child says: "Show me more!"</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="slide slide5">
                    <div class="slideWrapper">
                        <div class="caption">
                            <span>🖐 Ready to try?</span>
                        </div>
                        <div class="calltoaction">
                            <button class="button" @click="gotosignin">{{$t('app.registration')}}</button>
                        </div>
                        
                    </div>
                </div>

            </template>

            <div class="brandWrapper">
                <logotype :big="true"/>
            </div>

	        <div class="footerWrapper">
	            <footerComponent />
            </div>

		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	
.slide1
    background: #fdfdd0
    color : #000

.slide2
    border-bottom: $r solid #fdfdd0

.slide3
    border-bottom: $r solid #dc0050

</style>

<script>

import { mapState } from 'vuex';


export default {
	name: 'landing_about_page',
	components: {
	},

	data : function(){
		return { 
			searchEnabled : false,
            locales : {en : true, ru : true}

		}
	},

	computed: mapState({
        locale : function(state){
            return this.locales[state.locale] ? state.locale : 'en'
        }
	}),

	methods: {
		gotosignin : function(){
            this.$router.push('/signin').catch(e => {})
        }
	},

	mounted() {
       
	}
}
</script>
